/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import styled from '@emotion/styled'

import useSlider from '../../../hooks/useSlider'

import { useWindowSize } from '../../../hooks/useWindowSize'

const Container = styled.div`
  height: 100%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
`

const Scroller = styled.div`
  position: absolute;
  transition: transform 350ms;
  height: 100%;
  display: flex;
`

const Slide = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: opacity 350ms;
  text-transform: uppercase;
`

const Slider = React.memo(({ options, slideWidth = 600, slides }) => {
  // use addItem for anything that needs loading confirmation like images or embeds
  const { mobile } = useWindowSize()
  const { offset, addItem } = useSlider({
    total: slides.length,
    enabled: true,
    useLoaded: false,
    speed: 2000,
    ...options,
  })

  if (mobile) {
    slideWidth = slideWidth / 2
  }

  return (
    <Container sx={{ width: slideWidth }}>
      <Scroller
        sx={{
          transform: `translate3d(-${offset * slideWidth}px,0,0)`,
          width: `${slides.length * slideWidth}px`,
        }}
      >
        {mobile !== undefined &&
          slides.map((slide, index) => (
            <Slide sx={{ width: slideWidth }} key={index}>
              {slide}
            </Slide>
          ))}
      </Scroller>
    </Container>
  )
})

export default Slider
